export const dashboardTargetColor = '#ff5a5f'
export const languageStatisticsChartColor = '#fad223'
export const whatCategoryRatingChartColor = '#ff64b4'
export const howCategoryRatingChartColor = '#26A0FC'
export const programmingCategoryRatingChartColor = '#9bbe87'
export const dailyEffortsChartColor = '#ffa03c'
export const weeklyRatingChartColor = '#a5236e'
export const solvedProblemsChartColor = '#419bd2'
export const submissionStatusChartColor = '#46af96'
